module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-vault-1.d2414beb.svg";